(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sic-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sic-delivery-estimate')) return;
    const eu = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
    const transitByCountry = { GB: [4, 6], US: [5, 7], CA: [6, 10], AU: [10, 15], NZ: [10, 15], CH: [7, 10], NO: [7, 10] };
    const storageKey = 'sicDeliveryCountry';
    const dayFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', timeZone: 'UTC' });
    const monthFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
    const yearFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    const atelierFormat = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'Europe/Sofia' });
    const today = () => {
      const parts = atelierFormat.formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    };
    const addProductionDays = (date, count) => {
      const result = new Date(date);
      while (count > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) count -= 1;
      }
      return result;
    };
    const addTransitDays = (date, count) => {
      const result = new Date(date);
      result.setUTCDate(result.getUTCDate() + count);
      return result;
    };
    let countryDiscovery;
    const discoverCountry = () => {
      if (!countryDiscovery) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        countryDiscovery = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(4000) : undefined })
          .then(response => response.ok ? response.json() : null)
          .then(data => data && data.detected_values && data.detected_values.country ? data.detected_values.country.handle : null)
          .catch(() => null);
      }
      return countryDiscovery;
    };
    class SicDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          this.update();
          this.timer = setInterval(() => this.update(), 60000);
          return;
        }
        this.ready = true;
        const codes = JSON.parse(this.dataset.countryCodes || '[]');
        const names = JSON.parse(this.dataset.countryNames || '[]');
        this.countries = codes.map((code, index) => ({ code, name: (names[index] || code).replace(/&amp;/g, '&') })).filter(country => country.code !== 'IN');
        this.select = this.querySelector('[data-delivery-select]');
        this.change = this.querySelector('[data-delivery-change]');
        this.picker = this.querySelector('[data-delivery-picker]');
        this.countries.sort((a, b) => a.name.localeCompare(b.name, 'en'));
        this.select.replaceChildren(...this.countries.map(country => new Option(country.name, country.code)));
        let saved = null;
        try { saved = sessionStorage.getItem(storageKey); } catch (error) {}
        this.userSelected = this.countries.some(country => country.code === saved);
        this.country = this.userSelected ? saved : this.dataset.initialCountry;
        this.fallback = this.querySelector('[data-delivery-dates]').textContent;
        this.change.hidden = this.countries.length < 2;
        this.change.addEventListener('click', () => {
          this.picker.hidden = !this.picker.hidden;
          this.change.setAttribute('aria-expanded', String(!this.picker.hidden));
          if (!this.picker.hidden) this.select.focus();
        });
        this.select.addEventListener('change', () => {
          this.country = this.select.value;
          this.userSelected = true;
          try { sessionStorage.setItem(storageKey, this.country); } catch (error) {}
          this.update();
          this.picker.hidden = true;
          this.change.setAttribute('aria-expanded', 'false');
          this.change.focus();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.picker.hidden) {
            this.picker.hidden = true;
            this.change.setAttribute('aria-expanded', 'false');
            this.change.focus();
          }
        });
        this.update();
        if (!this.userSelected) {
          discoverCountry().then(code => {
            if (this.userSelected || !this.isConnected) return;
            if (this.countries.some(country => country.code === code)) {
              this.country = code;
              this.update();
            }
          });
        }
        this.timer = setInterval(() => this.update(), 60000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      update() {
        const country = this.countries.find(item => item.code === this.country);
        if (!country) {
          this.querySelector('[data-delivery-dates]').textContent = this.fallback;
          return;
        }
        const range = eu.has(country.code) ? [3, 5] : (transitByCountry[country.code] || [14, 25]);
        const orderDay = today();
        const from = addTransitDays(addProductionDays(orderDay, 5), range[0]);
        const to = addTransitDays(addProductionDays(orderDay, 7), range[1]);
        const sameYear = from.getUTCFullYear() === to.getUTCFullYear();
        const sameMonth = sameYear && from.getUTCMonth() === to.getUTCMonth();
        const fromText = sameMonth ? dayFormat.format(from) : (sameYear ? monthFormat.format(from) : yearFormat.format(from));
        const toText = sameYear ? monthFormat.format(to) : yearFormat.format(to);
        const result = fromText + '–' + toText;
        const dates = this.querySelector('[data-delivery-dates]');
        if (dates.textContent !== result) dates.textContent = result;
        this.querySelector('[data-delivery-country]').textContent = country.name;
        this.select.value = country.code;
      }
    }
    customElements.define('sic-delivery-estimate', SicDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

})();
